import { Collection } from "@type-r/models";
import { useLinked } from "@type-r/react";
import { CarrierType, localUserInfo, OrderModel } from "api";
import { CollapsableSection, Column, Columns, FormInput, PickItem, ReadOnly, TopSection } from "lqx-react";
import * as React from "react";
import { CollapsableAddress } from "../../../../../common/collapsableAddress";



export const Shipping = ({ shipping, ship_to, bill_to, end_customer, metadata, po_details, carrierTypes } : {
    shipping : OrderModel[ 'shipping' ],
    ship_to : OrderModel[ 'ship_to' ],
    bill_to : OrderModel[ 'bill_to' ],
    end_customer : OrderModel[ 'end_customer' ],
    metadata : OrderModel[ 'metadata' ],
    po_details: OrderModel[ 'po_details' ],
    carrierTypes: Collection<CarrierType>,
}) => {
    const readOnly = React.useContext( ReadOnly ) || !localUserInfo.canFull;
    const isFirstRender = useLinked(true);
    const $carrierTypePicked = useLinked<object>( null );

    React.useEffect(() => {
        let carrierType = carrierTypes.find(ct => ct.code === shipping.carrier);
        // in case po has a valid carrier already set which is not part of the carrier types list,
        // we add it to the list and set the value for the pickItem
        if(!carrierType && shipping.carrier){
            carrierType = {code:shipping.carrier, method:shipping.method} as CarrierType;
            carrierTypes.push(carrierType);
            $carrierTypePicked.set(carrierType);
        }
        // in case a carrier type was found in the carrier types list, then set the value for the pickItem
        else if(carrierType)
        {
            $carrierTypePicked.set(carrierType);
        }

        if(isFirstRender.value) {
            isFirstRender.set(false);
            return;
        }

        shipping.$.method.set(carrierType.method);
    }, [shipping.$.carrier]);

    return (
        <ReadOnly.Provider value={ readOnly }>
            <TopSection id="shipping" title="Shipping">
                <CollapsableSection id="shipping-details" title="Shipping Details">
                    <Columns>
                        <Column>
                            <FormInput label="Account" $value={shipping.$.account} />
                            <PickItem
                                        $value = {$carrierTypePicked}
                                        items = {carrierTypes}
                                        onChange = {(newValue) => {shipping.carrier = newValue.code;}}
                                        format={ ( x: any ) => x ? x.code : '' }
                                        filter={ ( x, filter ) => x.code.toLowerCase().indexOf( filter.toLowerCase() ) >= 0 }
                                        label="Carrier"
                                        required
                                        readOnly={readOnly}
                                    >
                                        { x => x.code }
                                    </PickItem>
                            <FormInput label="Distributor PO#" $value={shipping.$.po_number} required />
                            <FormInput label="Reseller PO#" $value={metadata.$.ref_sales_order_id} />
                        </Column>
                        <Column>
                            <FormInput label="Instructions" $value={shipping.$.instructions} />
                            <FormInput label="Method" $value={shipping.$.method} />
                            <FormInput label="Planned Delivery Date" $value={po_details.$.po_date} date />
                            {po_details.distributor_po_number ? <FormInput label="Distributor SW PO#" $value={po_details.$.distributor_po_number} /> : null}
                        </Column>
                    </Columns>
                </CollapsableSection>

                <CollapsableAddress id="ship-to" title="Ship To" model={ship_to} />
                <CollapsableAddress id="bill-to" title="Bill To" model={bill_to} />
                <CollapsableAddress id="end-customer" title="End Customer" model={end_customer} />
            </TopSection>
        </ReadOnly.Provider>
    )
}
